import { FC, useState } from 'react';
import { FooterState } from '../model';
export interface IInformaFooterProps {
	loginClass?: string;
}

export const InformaFooterComponent: FC<IInformaFooterProps> = ({ loginClass }) => {
	const [state] = useState(FooterState);
	const options = state.getOptions(state.baseUrl);
	return (
		<footer className={`l-footer l-footer-min ${loginClass!}`}>
			<div className='l-corporate-footer'>
				<div className='l-corporate-footer-logo-copyrights-wrapper'>
					<div className='l-corporate-footer-logo-copyrights'>
						<div className='l-corporate-footer-logo'>
							<a href='https://www.informamarkets.com/' target='blank'>
								<img src={state.logoUrl} alt='corporate-logo' />
							</a>
						</div>
						<div className='l-coporate-footer-copyright'>{state.copyright}</div>
					</div>
				</div>
				<div className='l-corporate-footer-links-wrapper'>
					<div className='l-coporate-footer-links'>
						<ul>
							{options.map((option, index) => {
								return (
									<li key={index}>
										<a href={option.href}>{option.label}</a>
									</li>
								);
							})}
						</ul>
					</div>
				</div>
			</div>
		</footer>
	);
};
